import { render, staticRenderFns } from "./UnitGroup.vue?vue&type=template&id=3a518f6a"
import script from "./UnitGroup.vue?vue&type=script&lang=js"
export * from "./UnitGroup.vue?vue&type=script&lang=js"
import style0 from "./UnitGroup.vue?vue&type=style&index=0&id=3a518f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports